export const PRODUCT_WALKTHROUGH_URL = 'https://hfr-investments.com/hfrconnect/';
